import { NgModule } from '@angular/core';
import { SettingsPageRoutingModule } from './settings-page-routing.module';
import { BootstrapModuleContract } from '../../support/modules/interfaces/bootstrap-module.interface';
import { MenuService } from '../../menu/services/menu.service';
import { BootstrapModule } from '../../support/modules/bootstrap-module';
import { MenuModule } from '../../menu/menu.module';

@NgModule({
    imports: [
        SettingsPageRoutingModule,
        MenuModule,
    ],
    exports: [
        SettingsPageRoutingModule
    ],
    declarations: [],
    providers: [],
})
export class SettingsPageModule extends BootstrapModule implements BootstrapModuleContract {

    public menus(menus: MenuService) {
        const menu = menus.get('sidebar');

        menu.add('settings', 'Settings', null, {
            icon: 'fa fa-cog', order: 95, permission: 'settings.read'
        });
        menu.get('settings')
            .add('configuration', 'Configuration', 'settings.index', {
                icon: 'fa fa-cogs', permission: 'settings.read'
            });

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/settings/settings-page.module.ts